import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=4aded289&scoped=true&"
import script from "./AddLocation.vue?vue&type=script&lang=ts&"
export * from "./AddLocation.vue?vue&type=script&lang=ts&"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=4aded289&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aded289",
  null
  
)

export default component.exports